export default __webpack_public_path__ + "static/media/storage.43010c0c.jpg";